//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { DateMixin } from '@/mixins/DateMixin';
export default {
  name: 'yearRangeDate',
  mixins: [DateMixin],
  mounted: function mounted() {
    this.$emit('change', [this.startYear, this.endYear, this.dateFormatFun2(this.dateTime)]);
  },
  methods: {
    // 开始年变化
    handleChange: function handleChange(value) {
      this.startYear = value;
      var startTime = this.startYear;
      var endTime = this.endYear;

      if (startTime >= endTime) {
        this.startYear = '';
        this.$message.error('开始年必须小于结束年');
      }

      if (this.dateTime) {
        this.$emit('change', [this.startYear, this.endYear, this.dateFormatFun2(this.dateTime)]);
      }
    },
    // 结束年变化
    handleChange2: function handleChange2(value) {
      this.endYear = value;
      var startTime = this.startYear;
      var endTime = this.endYear;

      if (startTime >= endTime) {
        this.endYear = '';
        this.$message.error('开始年必须小于结束年');
      }

      if (this.dateTime) {
        this.$emit('change', [this.startYear, this.endYear, this.dateFormatFun2(this.dateTime)]);
      }
    },
    onDateChange: function onDateChange(date, dateString) {
      this.dateTime = date;

      if (this.startYear && this.endYear) {
        this.$emit('change', [this.startYear, this.endYear, dateString]);
      }
    }
  }
};